import { useEffect } from 'react';
import { OnboardingTrialStepsType } from 'sling-sdk/src/authentication/types';
import type { ClientFlags } from 'sling-sdk/src/authentication/types';

import isStepCompleted from '../helpers/isStepCompleted';

import type { CompleteStep } from './useCompleteStep';

type Props = {
  availableSteps: OnboardingTrialStepsType[];
  completeStep: CompleteStep;
  clientFlags: ClientFlags;
  isTimeTrackingEnabled: boolean;
};

const useAutocompleteEnableTimeClockStep = ({
  availableSteps,
  completeStep,
  clientFlags,
  isTimeTrackingEnabled,
}: Props) => {
  useEffect(() => {
    if (!clientFlags) {
      // if we don't have client flags at all we're not ready to mark it completed, waiting for them to load.
      return;
    }

    if (isStepCompleted(clientFlags, OnboardingTrialStepsType.enableTimeClock)) {
      // step was completed before, no need to proceed further
      return;
    }

    if (isTimeTrackingEnabled) {
      completeStep(OnboardingTrialStepsType.enableTimeClock, availableSteps);
    }
  }, [availableSteps, clientFlags, completeStep, isTimeTrackingEnabled]);

  return null;
};

export default useAutocompleteEnableTimeClockStep;
